import Vue from 'vue';
import Vuetify, {
  VSnackbar, VBtn, VIcon, VRow, VCol, VSpacer, VBreadcrumbs, VTextField,
  VCard, VCardText, VCardActions, VCardTitle, VCardSubtitle,
  VSelect, VDatePicker, VMenu, VProgressCircular, VDialog,
  VList, VListItem, VListItemAction, VListItemContent, VListItemGroup,
  VListItemSubtitle, VListItemTitle, VToolbarTitle, VToolbar,
  VChip, VChipGroup, VTooltip, VAutocomplete, VContainer, VContent, VBadge,
  VTextarea, VTimeline, VTimelineItem, VDivider, VRating,
  VListItemIcon, VTabItem, VTabsItems, VTabs, VTab, VAvatar, VSubheader,
  VPagination, VImg, VBtnToggle,
} from 'vuetify/lib';
import PixLogo from '../components/PixLogo.vue';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon,
    VRow,
    VCol,
    VSpacer,
    VBreadcrumbs,
    VTextField,
    VCard,
    VCardText,
    VCardActions,
    VCardTitle,
    VCardSubtitle,
    VSelect,
    VDatePicker,
    VMenu,
    VProgressCircular,
    VDialog,
    VList,
    VListItem,
    VListItemAction,
    VListItemContent,
    VListItemGroup,
    VListItemSubtitle,
    VListItemTitle,
    VToolbarTitle,
    VToolbar,
    VChip,
    VChipGroup,
    VTooltip,
    VAutocomplete,
    VContainer,
    VContent,
    VBadge,
    VTextarea,
    VTimeline,
    VTimelineItem,
    VDivider,
    VRating,
    VListItemIcon,
    VTabItem,
    VTabsItems,
    VTabs,
    VTab,
    VAvatar,
    VSubheader,
    VPagination,
    VImg,
    VBtnToggle,
  },
});

const PRIMARY_COLOR = '#305CA5';
const SECONDARY_COLOR = '#EF4F1F';

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: PRIMARY_COLOR,
        secondary: SECONDARY_COLOR,
        accent: SECONDARY_COLOR,
      },
    },
  },
  icons: {
    values: {
      customPix: {
        component: PixLogo,
      },
    },
  },
});
